import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { map } from 'rxjs/operators';
import { AppData } from 'src/app/app.data';
import { AppSettings } from 'src/app/app.settings';
import { Settings } from 'src/app/app.settings.model';
import { Utils } from '../utils';

@Injectable({
  providedIn: 'root'
})
export class PaymentService {

  settings: Settings;
  apiEndPoint: string = Utils.getApiEndPoint(); // environment.APIEndpoint;

  constructor(private http: HttpClient,
    private appSettings: AppSettings,
    private appData: AppData,
    private translate: TranslateService) {

    this.settings = appSettings.settings;
  }


  getPrePaymentRequestDataForEvent(provider:string, eventID: number){
    return this.http.get<any>(this.apiEndPoint + `PaymentApi/GetPrePaymentRequestDataForEvent/${provider}/${eventID}`)
      .pipe(map(result => {
        return result;
      }));
  }

  postPrePaymentRequest(dataToSend: any) {
    return this.http.post<any>(this.apiEndPoint + `PaymentApi/SaveCustomerPaymentRequest`, JSON.stringify(dataToSend))
      .pipe(map(result => {
        return result;
      }));
  }
}
